import script from "./deatil.vue?vue&type=script&setup=true&lang=js"
export * from "./deatil.vue?vue&type=script&setup=true&lang=js"

import "./deatil.vue?vue&type=style&index=0&id=af4bc63c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af4bc63c"]])

export default __exports__